import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchWorkoutFeedbackCommentsArgs } from '../api/types/workoutFeedbackComments.types';
import type {
  FetchWorkoutFeedbackArgs,
  FetchWorkoutResultsArgs,
} from '../api/types/workouts.types';

import {
  fetchWorkoutFeedbackComments,
  fetchWorkoutFeedback,
  fetchWorkoutResults,
} from '../api/workouts.api';
import { fetchWorkoutProgressById } from '../api/progress.api';

export const progressQueryKeys = createQueryKeys('progress', {
  fetchWorkoutProgress: ({ workoutId }: { workoutId: string }) => ({
    queryFn: () =>
      fetchWorkoutProgressById({
        workoutId,
      }),
    queryKey: [workoutId],
  }),
  fetchWorkoutFeedback: ({
    organizationId,
    workoutId,
    userId,
  }: FetchWorkoutFeedbackArgs) => ({
    queryFn: () => fetchWorkoutFeedback({ organizationId, userId, workoutId }),
    queryKey: [organizationId, userId, workoutId],
  }),
  fetchWorkoutResults: ({
    organizationId,
    workoutId,
    userId,
  }: FetchWorkoutResultsArgs) => ({
    queryFn: () => fetchWorkoutResults({ organizationId, userId, workoutId }),
    queryKey: [organizationId, userId, workoutId],
  }),
  fetchWorkoutFeedbackComments: ({
    organizationId,
    userId,
    workoutId,
  }: FetchWorkoutFeedbackCommentsArgs) => ({
    queryFn: () =>
      fetchWorkoutFeedbackComments({ organizationId, userId, workoutId }),
    queryKey: [organizationId, userId, workoutId],
  }),
});
